export const FLOW_IDS = ["pingwi", "pingflo", "pingpro", "pingmynd"];

export const FLOW_ACCENT = {
  pingwi: "#FFA451",
  pingflo: "#2A9BB5",
  pingpro: "#0B1F33",
  pingmynd: "#0F7B6C",
  // Legacy aliases for backward compatibility
  pingwe: "#FFA451",
  pingflow: "#2A9BB5",
  pingmind: "#0F7B6C",
};

/** Normalizes legacy flow ids if accessed from old bookmarks */
export function normalizeFlowId(rawId) {
  const id = String(rawId || "").toLowerCase();
  if (id === "pingwe") return "pingwi";
  if (id === "pingflow") return "pingflo";
  if (id === "pingmind") return "pingmynd";
  return id;
}
